module.exports = __webpack_public_path__ + "static/media/png-simple-icon.1790f0c8.svg";